import { Tooltip } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import type { ReactNode } from 'react';

interface LabelWithInfoProps {
  label: ReactNode;
  info: ReactNode;
  iconSize?: number;
  tooltipWidth?: number;
  /**
   * Optionale Einheit (Phase 29, `unitLabel.tsx`), die zwischen Label und
   * Info-Icon in Klammern erscheint -- z. B. "Wasserentnahme (m³)". Ohne
   * `unit` bleibt die Darstellung zeichengleich zu vorher.
   */
  unit?: string;
}

/**
 * Input-label decorator: renders the label text followed by an InfoCircle
 * icon. On hover the icon shows a tooltip with the `info` content.
 *
 * Usage:
 *   <TextInput label={<LabelWithInfo label="Foo" info="Help text" />} />
 */
export function LabelWithInfo({
  label,
  info,
  iconSize = 16,
  tooltipWidth = 280,
  unit,
}: LabelWithInfoProps) {
  return (
    <Tooltip label={info} multiline w={tooltipWidth} withArrow position="top">
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 4, cursor: 'help' }}>
        {label}
        {unit ? ` (${unit})` : null}
        <IconInfoCircle
          size={iconSize}
          color="var(--mantine-color-vdzGray-6)"
          style={{marginBottom: '3px'}}
        />
      </span>
    </Tooltip>
  );
}
